import React, { useState, useEffect, useRef, } from 'react';
import { useSelector, } from 'react-redux'
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Card, Typography, Grid, } from '@material-ui/core';
import { fetchAgenceRevenue, fetchAgenceTodaysStats, fetchPartnerRevenue, fetchMonthRevenue, fetchUserTodaysStats, fetchPartnerTodaysStats, fetchAdminTodaysStats, } from 'firebaseHelpers/users'

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  item: {
    padding: theme.spacing(3),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      '&:not(:last-of-type)': {
        borderRight: `1px solid ${theme.palette.divider}`
      }
    },
    [theme.breakpoints.down('sm')]: {
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.divider}`
      }
    }
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  label: {
    marginLeft: theme.spacing(1)
  },
  overline: {
    marginTop: theme.spacing(1)
  }
}));

const Statistics = props => {
  const { userInfos, className, ...rest } = props;

  const classes = useStyles();
  const isCancelled = useRef(false)
  const session = useSelector(state => state.session)
  const [isLoading, setIsLoading] = useState(false)
  const [withdrawMoney, setWithdrawMoney] = useState(0)
  const [monthIncome, setMonthIncome] = useState(0)
  const [monthNetProfit, setMonthNetProfit] = useState(0)
  const [todaysIncome, setTodaysIncome] = useState(0)
  const [todaysBookings, setTodaysBookings] = useState(0)
  const isAdmin = session.user.roles === 'admin'

  const fetchDataAgence = async () => {
    try {
      setIsLoading(true)
      const withdrawMoney = await fetchAgenceRevenue(session.user)
      const todaysData = await fetchAgenceTodaysStats(session.user)

      if (!isCancelled.current) {
        setIsLoading(false)
        setWithdrawMoney(withdrawMoney.toFixed(2))
        setTodaysIncome(todaysData.todaysIncome.toFixed(2))
        setTodaysBookings(todaysData.nbBookings)
      }
    } catch (error) {
      console.log(error)
      // setError(true)
    }
  }

  const fetchDataPartner = async () => {
    try {
      setIsLoading(true)
      const withdrawMoney = await fetchPartnerRevenue(session.user)
      const todaysData = await fetchPartnerTodaysStats(session.user)

      if (!isCancelled.current) {
        setIsLoading(false)
        setWithdrawMoney(withdrawMoney.toFixed(2))
        setTodaysIncome(todaysData.todaysIncome.toFixed(2))
        setTodaysBookings(todaysData.nbBookings)
      }
    } catch (error) {
      // setError(true)
    }
  }

  const fetchDataAdmin = async () => {
    try {
      setIsLoading(true)
      const revenue = await fetchMonthRevenue(session.user)
      const todaysData = await fetchAdminTodaysStats(session.user)

      if (!isCancelled.current) {
        setIsLoading(false)
        setMonthIncome(revenue.totalPrice.toFixed(2))
        setMonthNetProfit(revenue.totalProfit.toFixed(2))
        setTodaysIncome(todaysData.todaysIncome.toFixed(2))
        setTodaysBookings(todaysData.nbBookings)
      }
    } catch (error) {
      // setError(true)
    }
  }

  const fetchDataUser = async () => {
    try {
      setIsLoading(true)
      const todaysData = await fetchUserTodaysStats(session.user)

      if (!isCancelled.current) {
        setIsLoading(false)
        setWithdrawMoney(session.user.withdrawMoney.toFixed(2))
        setTodaysIncome(todaysData.todaysIncome.toFixed(2))
        setTodaysBookings(todaysData.nbBookings)
      }
    } catch (error) {
      // setError(true)
    }
  }

  useEffect(() => {
    isCancelled.current = false
    if (session.user.roles === 'admin') {
      fetchDataAdmin()
    } else if (session.user.roles === 'partner') {
      fetchDataPartner()
    } else if (session.user.roles === 'agence') {
      fetchDataAgence()
    } else {
      fetchDataUser()
    }

    return () => {
      isCancelled.current = true
    }
  }, []);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        alignItems="center"
        container
        justify="space-between"
      >
        {!isAdmin && (
          <Grid
            className={classes.item}
            item
            md={isAdmin ? 3 : 4}
            sm={6}
            xs={12}
          >
            <Typography variant="h2">{withdrawMoney} AED</Typography>
            <Typography
              className={classes.overline}
              variant="overline"
            >
              Current Balance
            </Typography>
          </Grid>
        )}
        {isAdmin && (
          <Grid
            className={classes.item}
            item
            md={3}
            sm={6}
            xs={12}
          >
            <Typography variant="h2">{monthIncome} AED</Typography>
            <Typography
              className={classes.overline}
              variant="overline"
            >
              Month's Income
            </Typography>
          </Grid>
        )}
        {isAdmin && (
          <Grid
            className={classes.item}
            item
            md={3}
            sm={6}
            xs={12}
          >
            <Typography variant="h2">{monthNetProfit} AED</Typography>
            <Typography
              className={classes.overline}
              variant="overline"
            >
              Month's Net Profit
            </Typography>
          </Grid>
        )}
        <Grid
          className={classes.item}
          item
          md={isAdmin ? 3 : 4}
          sm={6}
          xs={12}
        >
          <Typography variant="h2">{todaysIncome} AED</Typography>
          <Typography
            className={classes.overline}
            variant="overline"
          >
            Today's Income
          </Typography>
        </Grid>
        <Grid
          className={classes.item}
          item
          md={isAdmin? 3 : 4}
          sm={6}
          xs={12}
        >
          <Typography variant="h2">{todaysBookings}</Typography>
          <Typography
            className={classes.overline}
            variant="overline"
          >
            Today's Bookings
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
};

Statistics.propTypes = {
  className: PropTypes.string
};

export default Statistics;
